import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

const ProductElement = (props) => {
    const {
      choiceID,
      productGroupID,
      selection,
      product,
      removeSelection,
      addSelection,
    } = props;

    let isSelected = false;


    selection.filter(s => s.choiceID === choiceID && s.productGroupID === productGroupID
      && s.product.id === product.id)
    .map(() => {
      isSelected = true;
      return isSelected;
    });

    return (
      <div key={product.id} className={isSelected ? 'teamsportProduct selected' : 'teamsportProduct'}>
        <div className="removeItem" onClick={() => removeSelection(product.id, props.productSubgroupID)} role="button" tabIndex="0" />
        <img
          onClick={() => addSelection(props)}
          className="productImage"
          src={product.image}
          alt="product img"
          role="button"
          tabIndex="0"
          style={{ outline: 'none' }}
        />
        {isSelected ? <div className="selectBracket" /> : null}
      </div>
    );
};


const mapDispatch = dispatch => (
  {
    addSelection: props => dispatch({
      type: 'ADD_SELECTION',
      selection: {
        choiceID: props.choiceID,
        productGroupID: props.productGroupID,
        product: props.product,
        productSubgroupID: props.productSubgroupID,
      },
    }),
    removeSelection: (productID, productSubgroupID) => dispatch({
      type: 'REMOVE_SELECTION',
      productID,
      productSubgroupID,
    }),
  }
);

const mapState = state => (
  {
    selection: state.selection,
  }
);

export default withRouter(connect(mapState, mapDispatch)(ProductElement));
